/**
 * Resuelve la URL base del backend (sin /api).
 * En localhost usa el proxy de CRA (/api -> localhost:3030) salvo REACT_APP_USE_REMOTE_API=true.
 */
export function resolveApiUrl(): string {
  const isDev = process.env.NODE_ENV !== 'production';

  if (isDev && typeof window !== 'undefined') {
    const host = window.location.hostname;
    if ((host === 'localhost' || host === '127.0.0.1') && process.env.REACT_APP_USE_REMOTE_API !== 'true') {
      // Misma origin que el dev server; craco proxy reenvía /api al backend local.
      return '';
    }
  }

  const localDefault = process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:3030';

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (process.env.NODE_ENV === 'production') {
    return 'https://pet-contest.petflix.io';
  }

  return localDefault;
}
